import TommyHeadshot from "../images/tommy_headshot.png";
import styles from '../Style';
import {createUseStyles} from "react-jss";
import useMobile from "../../../template/Mobile";
const useStyle = createUseStyles(styles);

export default function TopOfPage() {

    const style = useStyle();
    const isMobile = useMobile();

    return <div className={isMobile ? style.mobilePortfolioOverviewContent : style.portfolioOverviewContent}>
        <div className={style.overviewText}>
            <h1 className={style.portfolioOverviewHeader}>Thomas Galletta</h1>
            <h2 className={style.portfolioOverviewSubheader}>Computer Scientist</h2>
            <p>📍 Knoxville, TN</p>
            <p>✉️ Email me at <a href={"mailto:tommy.tpg03@gmail.com"}>tommy.tpg03@gmail.com</a></p>
            <p>💼 Find me on <a href={"https://www.linkedin.com/in/tommyg128"}>LinkedIn</a></p>
            <p>👾 Find me on <a href={"https://www.github.com/Penguini128"}>GitHub</a></p>
            <p>📝 Download my <a href={'/resume'}>resume</a></p>
        </div>
        <img className={style.headshotImage} src={TommyHeadshot}/>
    </div>
}